
import Vue from 'vue'

const getDefaultState = () => {
    return {
        productPricingRequest: {
            id: 0,
            idServiceProject: null,
            status: 0,
            listItems: [],
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`product-pricing-request/list`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                return result.data.result;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list product pricing requests: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`product-pricing-request/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get product pricing request`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get product pricing request: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, request) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`product-pricing-request/create-update`, request,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = request.id === 0 ? "Record created successfully" : "Register updated with success!";

                return {
                    success: true,
                    id: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    id: 0,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {
                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async SendToApproval(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`product-pricing-request/send-to-approval/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200 || result.status === 204) {
                return {
                    success: true,
                    message: "Request sent for approval successfully!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error sending request for approval!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error sending for approval: [${error.response.data}]`
                };
            }
            else {
                return {
                    success: false,
                    message: `Error sending for approval: [${error}]`
                };
            }
        }
    },

    async Cancel(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`product-pricing-request/cancel/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200 || result.status === 204) {
                return {
                    success: true,
                    message: "Request canceled successfully!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error canceling the request!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error canceling: [${error.response.data}]`
                };
            }
            else {
                return {
                    success: false,
                    message: `Error canceling: [${error}]`
                };
            }
        }
    },

    async Approve(_, { id, request }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`product-pricing-request/approve/${id}`, request,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200 || result.status === 204) {
                return {
                    success: true,
                    message: "Request approved successfully!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error approving the request!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error approving: [${error.response.data}]`
                };
            }
            else {
                return {
                    success: false,
                    message: `Error approving: [${error}]`
                };
            }
        }
    },

    async Deny(_, { id, request }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`product-pricing-request/deny/${id}`, request,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200 || result.status === 204) {
                return {
                    success: true,
                    message: "Request denied successfully!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error denying the request!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error denying: [${error.response.data}]`
                };
            }
            else {
                return {
                    success: false,
                    message: `Error denying: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.productPricingRequest, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
